import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ui-file',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <input
      type="file"
      [id]="id"
      [name]="name"
      [accept]="accept"
      [multiple]="multiple"
      [disabled]="disabled"
      [class]="fileClass"
      [attr.aria-label]="ariaLabel"
      (change)="onChange($event)"
    />
  `,
})
export class UiFileComponent {
  @Input() id?: string;
  @Input() name?: string;
  @Input() accept?: string;
  @Input() multiple = false;
  @Input() disabled = false;
  @Input() ariaLabel?: string;
  @Input() fileClass = '';

  @Output() fileChange = new EventEmitter<FileList | null>();
  @Output() change = new EventEmitter<Event>();

  onChange(event: Event): void {
    this.change.emit(event);
    this.fileChange.emit((event.target as HTMLInputElement).files);
  }
}
